module.exports = __webpack_public_path__ + "media/home/DigitalStorage-x2-d6cdbd52.png";